class ProductLabels extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)

    this.els.item.elements.forEach((item) => {
      this.listeners.add(item, 'mouseenter', this.handleMouseEnter)
      this.listeners.add(item, 'mouseleave', this.handleMouseLeave)
    })
  }

  handleMouseEnter (e) {
    const labelSplit = e.currentTarget.dataset.name.split('|')

    if (labelSplit.length > 1) {
      this.els.name.element.innerHTML = `${labelSplit[0]} <span class="${this.secondaryClass}">${labelSplit[1]}</span>`
    } else {
      this.els.name.element.innerHTML = e.currentTarget.dataset.name
    }
  }

  handleMouseLeave () {
    const labelSplit = this.els.name.element.dataset.default.split('|')

    if (labelSplit.length > 1) {
      this.els.name.element.innerHTML = `${labelSplit[0]} <span class="${this.secondaryClass}">${labelSplit[1]}</span>`
    } else {
      this.els.name.element.innerHTML = this.els.name.element.dataset.default
    }
  }

  get secondaryClass () {
    return this.dataset.secondaryClass || ''
  }
}

if (!customElements.get('product-labels')) {
  customElements.define('product-labels', ProductLabels)
}
